import page0 from './_0_employment_based_nonimmigrant_visa_information'
import page1 from './_1_temporary_need_information'
import page2 from './_2_employer_information'
import page3 from './_3_employer_poc_information'
import page4 from './_4_agent_or_attorney_information'
import page5 from './_5_employment_and_wage_information'
import page6 from './_6_employer_labor_condition_statements'
import page7 from './_7_h1b_additional_employer_labor_statements'
import page8 from './_8_employer_obligations'
import page9 from './_9_LCA_preparer'
import page10 from './_10_appendix_A_educational_attainment_documentation'
import page11 from './_11_application_documents'

const form_meta = {
    code: 'Form ETA-9035 & 9035E',
    name: 'Labor Condition Application for Nonimmigrant Workers'
}

const form_nav = [

    {
        name: 'Employment-Based Nonimmigrant Visa Information',
        prefix: 'A',
    },
    {
        name: 'Temporary Need Information',
        prefix: 'B',
    },
    {
        name: 'Employer Information',
        prefix: 'C',
    },
    {
        name: 'Employer Point of Contact Information',
        prefix: 'D',
    },
    {
        name: 'Attorney or Agent Information <br/>(if applicable)',
        prefix: 'E',
    },
    {
        name: 'Employment and Wage <br/>Information',
        prefix: 'F'
    },
    {
        name: 'Employer Labor Condition Statements',
        prefix: 'G',
        note: `
        In order for your application to be processed, you MUST read Section G of the Form ETA-9035CP - General Instructions for the 9035 & 9035E under the heading “Employer Labor Condition Statements” and agree to all four (4) labor condition statements summarized below:<br/><br/><ol><li><strong>Wages:</strong> The employer shall pay nonimmigrant workers at least the prevailing wage or the employer’s actual wage, whichever is higher, and pay for non-productive time. The employer shall offer nonimmigrant workers benefits and eligibility for benefits provided as compensation for services on the same basis as the employer offers to U.S. workers. The employer shall not make deductions to recoup a business expense(s) of the employer including attorney fees and other costs connected to the performance of H-1B, H-1B1, or E-3 program functions which are required to be performed by the employer. This includes expenses related to the preparation and filing of this LCA and related visa petition information. 20 CFR 655.731;</li><br/><li><strong>Working Conditions:</strong> The employer shall provide working conditions for nonimmigrants which will not adversely affect the working conditions of workers similarly employed. The employer’s obligation regarding working conditions shall extend for the duration of the validity period of the certified LCA or the period during which the worker(s) working pursuant to this LCA is employed by the employer, whichever is longer. 20 CFR 655.732;</li> <br/><li><strong>Strike, Lockout, or Work Stoppage:</strong> At the time of filing this LCA, the employer is not involved in a strike, lockout, or work stoppage in the course of a labor dispute in the occupational classification in the area(s) of intended employment. The employer will notify the Department of Labor within 3 days of the occurrence of a strike or lockout in the occupation, and in that event the LCA will not be used to support a petition filing with the U.S. Citizenship and Immigration Services (USCIS) until the DOL Employment and Training Administration (ETA) determines that the strike or lockout has ended. 20 CFR 655.733;</li><br/><li><strong>Notice:</strong> Notice of the LCA filing was provided no more than 30 days before the filing of this LCA or will be provided on the day this LCA is filed to the bargaining representative in the occupation and area of intended employment, or if there is no bargaining representative, to workers in the occupation at the place(s) of employment either by electronic or physical posting. This notice was or will be posted for a total period of 10 days, except that if employees are provided individual direct notice by e-mail, notification need only be given once. A copy of the notice documentation will be maintained in the employer’s public access file. A copy of this LCA will be provided to each nonimmigrant worker employed pursuant to the LCA. The employer shall, no later than the date the worker(s) report to work at the place(s) of employment, provide a signed copy of the certified LCA to the worker(s) working pursuant to this LCA. 20 CFR 655.734.</li></ol>
        `
    },
    {
        name: 'H-1B Additional Employer Labor Condition Statements',
        prefix: 'H',
    },
    {
        name: 'Employer Obligations',
        prefix: 'I/J',
        note: `<small><strong>Notice of Obligations</strong>
        <p>
        A. Upon receipt of the certified LCA, the employer must take the following actions: 
        Print and sign a hard copy of the LCA if filing electronically(20 CFR 655.705(c)(3));
        Maintain the original signed and certified LCA in the employer's files (20 CFR 655.705(c)(2)); 20 CFR 655.730(c)(3) ; and 20 CFR 655.760)
        Make a copy of the LCA, as well as necessary supporting documentation required by the Department of Labor regulations, available for public examination in a public access file at the employer's principal place of business in the U.s> or at the place of employment within one working day after the date on which the LCA is filed with the Department of Labor (20 CFR 655.705(c)(2) and 20 CFR 655.760).
        </p>

        <p>
        B. The employer must develop sufficient documentation to meet its burden of proof with respect to the validity of the statements made in its LCA and the accuracy of information provided, in the event that such statements or information is challenged (20 CFR 655.705(c)(5) and 20 CFR 655.700(d)(iv)).
        </p>

        <p>
        C. The employer must make this LCA, supporting documentation, and other records available to officials of the Department of Labor upon request during any investigation under the immigration and Nationality Act (20 CFR 655.760 and 20 CFR Subpart I).
        </p>

        <p>
        I declare under penalty of perjury that I have read and reviewed this application and that to the best of my knowledge, the information contained therein is true and accurate. I understand that to knowingly furnish materially false information in the preparation of this form and any supplemental thereto or to aid, abet, or counsel another to do so is a federal offense punishable fines, imprisonment, or both (18 U.S.C 2, 1001,1546,1621).
        </p></small>
        `
    },
    {
        name: 'LCA Preparer',
        prefix: 'K',
    },
    {
        name: 'Appendix A - Educational Attainment Documentation',
        prefix: 'APP <br/>A',
        classes: 'label-prefix-appx'
    },
    {
        name: 'Application Documents',
        symbol: 'upload'
    }
]

export { form_meta, form_nav }

export default [
    page0,
    page1,
    page2,
    page3,
    page4,
    page5,
    page6,
    page7,
    page8,
    page9,
    page10,
    page11
]
